import React, { FC } from 'react';
import { Layout, ConfigProvider } from 'antd';
import styled from 'styled-components';
import Pages from './pages';
import TopBarLoader from './components/TopBarLoader';
import NoInternetModal from './components/NoInternetModal';
import { useInitApp } from './controllers/auth';
import { useUserActivity } from './controllers/userActivity';
import { useNetworkStatus } from './hooks/useNetworkStatus';
import {
  useDirection,
  useGetAntdLocale,
  useGetAntdValidateMessages,
  useSetHtmlLang,
} from './hooks/i18nHooks';
import { PageTitleProvider } from './context/PageTitleContext';
import './App.css';

const App: FC = () => {
  const locale = useGetAntdLocale();
  const direction = useDirection();
  const validateMessages = useGetAntdValidateMessages();
  const isAppReady = useInitApp();
  useSetHtmlLang();

  const { onEvent } = useUserActivity();
  const isOnline = useNetworkStatus();

  const handleRetry = () => {
    // Force a page reload to check connection.
    window.location.reload();
  };

  if (!isAppReady) return null;

  return (
    <PageTitleProvider>
      <ConfigProvider form={{ validateMessages }} locale={locale} direction={direction}>
        <StyledLayout
          className="App"
          onClick={onEvent}
          onScrollCapture={onEvent}
          onDrop={onEvent}
          onKeyDown={onEvent}
        >
          <TopBarLoader />
          <Pages />
          <NoInternetModal visible={!isOnline} onRetry={handleRetry} />
        </StyledLayout>
      </ConfigProvider>
    </PageTitleProvider>
  );
};

const StyledLayout = styled(Layout)`
  min-height: 100vh;
  //background-color: red;
`;

export default App;
